import { StickerModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class StickerService extends ApiService<StickerModel> {
	constructor() {
		super('sticker');
	}
}

export default new StickerService();
